import { render, staticRenderFns } from "./StrategicValuesList.vue?vue&type=template&id=5efb8f49"
import script from "./StrategicValuesList.vue?vue&type=script&lang=js"
export * from "./StrategicValuesList.vue?vue&type=script&lang=js"
import style0 from "./StrategicValuesList.vue?vue&type=style&index=0&id=5efb8f49&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports